import {borderRadius, primaryColor} from "./variables";

export const getKeyframes = (type: string) => {
    switch (type) {
        case 'fadeIn':
            return `
                @keyframes fadeIn {
                    to {
                        opacity: 1;
                    }
                }
            `;
        case 'scaleIn':
            return `
                opacity: .5;
                transform: scale(.6);
                @keyframes scaleIn {
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
            `;
        case 'fadeOut':
            return `
                @keyframes fadeOut {
                    to {
                        opacity: 0;
                    }
                }
            `;
        case 'rotate':
            return `
                @keyframes infiniteRotate {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }
            `;
        default:
            return '';
    }
}

export const customScrollBarStyle = (isMacOs: boolean) => {
    if (!isMacOs) {
        return `
        ::-webkit-scrollbar{
     width: 5px;
     height: 5px;
     display: none;
   }
   ::-webkit-scrollbar-track{
     background-color: var(--scrollbar-track);
     border-radius: ${borderRadius}px;
   }
   ::-webkit-scrollbar-thumb{
     background-color: ${primaryColor};
     border-radius: ${borderRadius};
   }
   ::-webkit-scrollbar-thumb:active{
     background-color: #1d6fe8;
   }
  
  :hover {
    ::-webkit-scrollbar{
      display: inline-table;
    }
  }`
    } else {
        return '';
    }
}